import "./SinglePostTemplate.module.css"
import Header from "@/reusable_sections/Header"
import CauseArticle from "./sections/CauseArticle"
import Footer from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <Header />
      <CauseArticle />
      <Footer />
    </div>
  )
}
